<template>
    <v-container
            class="fill-height"
            fluid
    >
        <v-row
                align="center"
                justify="end"
        >
            <v-col
                    cols="12"
                    sm="8"
                    md="4"
            >
                <v-card class="elevation-12">
                    <div style="height: 0.5rem;">
                        <v-progress-linear
                                v-show="loading"
                                height="8"
                                indeterminate
                                color="primary"
                        ></v-progress-linear>
                    </div>
                    <v-card-text>
                        <v-container>
                            <v-row class="header-image-container">
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <v-img
                                            src="./../assets/logo.jpg"
                                            lazy-src="./../assets/logo.jpg"
                                            class="grey lighten-2"
                                            max-width="250"
                                    ></v-img>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">

                                    <i18n path="join.helloTextWithContext" tag="p" class="text-justify"
                                          v-if="context">
                                        <span slot="context"><span class="font-weight-bold">{{ context }}</span></span>
                                    </i18n>
                                    <p v-else class="text-justify">
                                        {{ $t("join.helloText") }}
                                    </p>

                                    <v-alert v-show="error" type="error"
                                             transition="scale-transition">
                                        {{error}}
                                    </v-alert>

                                    <v-alert v-show="success" type="success"
                                             transition="scale-transition">
                                        {{success}}
                                    </v-alert>

                                    <v-form @keyup.native.enter="submit">
                                        <v-text-field
                                                :label="$t('common.username') + '*'"
                                                name="userName"
                                                type="text"
                                                disabled
                                                v-model="user.userName"

                                                :error-messages="usernameErrors"
                                                @input="$v.user.userName.$touch()"
                                                @blur="$v.user.userName.$touch()"
                                        ></v-text-field>
                                        <v-text-field
                                                autofocus
                                                id="password"
                                                :label="$t('common.password') + '*'"
                                                name="password"
                                                v-model="user.password"


                                                :type="showPassword ? 'text' : 'password'"
                                                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                                @click:append="showPassword = !showPassword"

                                                :error-messages="passwordErrors"
                                                @input="$v.user.password.$touch()"
                                                @blur="$v.user.password.$touch()"
                                        ></v-text-field>
                                    </v-form>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-container>
                            <v-row
                            >
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <v-btn x-large color="success" class="login-button" :disabled="loading"
                                           @click="submit">{{ $t("common.login") }}
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <router-link
                                            class="caption"
                                            :to="{ name: 'register' }">
                                        {{ $t("join.registerLink") }}
                                    </router-link>
                                    <br>
                                    <router-link
                                            class="caption"
                                            :to="{ name: 'requestPasswordReset' }">
                                        {{ $t("join.forgotPasswordLink") }}
                                    </router-link>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {required, minLength, maxLength, email} from 'vuelidate/lib/validators'

    export default {
        name: 'InviteJoin',

        validations: {
            user: {
                userName: {
                    required
                },
                password: {
                    required
                }
            }
        },

        data: () => ({
            error: null,
            success: null,
            loading: false,

            context: '',

            user: {
                userName: '',
                password: ''
            },
            showPassword: false,
        }),
        computed: {
            usernameErrors() {
                const errors = []

                if(!this.$v.user.userName.$dirty) {
                    return errors
                }

                !this.$v.user.userName.required && errors.push(this.$t('common.errors.fieldRequired'))
                return errors
            },
            passwordErrors() {
                const errors = []

                if(!this.$v.user.password.$dirty) {
                    return errors
                }

                !this.$v.user.password.required && errors.push(this.$t('common.errors.fieldRequired'))

                return errors
            },
        },
        created() {
            const username = this.$route.query.user;
            const context = this.$route.query.ctx;

            if(typeof username !== 'undefined') {
                this.user.userName = username;
            }

            if(typeof context !== 'undefined') {
                this.context = context;
            }
        },
        methods: {
            forwardToSharesuite() {
                location.replace(location.origin + "/" + process.env.VUE_APP_WEB_APP_PATH);
            },
            submit() {
                this.$v.$touch()
                if(!this.$v.$invalid) {
                    this.loading = true;
                    this.error = null;
                    this.success = null;

                    const preLogout = new Promise((resolve, reject) => {
                        this.$store.dispatch('isLoggedIn').then((response) => {
                            if(response.success === true && response.result !== false && response.result.user) { // Logged in
                                this.$store.dispatch('logout').then(() => {
                                    resolve();
                                });
                            } else {
                                resolve();
                            }
                        });
                    });

                    preLogout.then(() => {
                        this.$store.dispatch('login', {
                            user: this.user
                        }).then((response) => {
                            if(response.success === true && response.result !== false && response.result.user) {
                                this.$store.dispatch('joinContext', {
                                    token: this.$route.query.token
                                }).then((response) => {
                                    this.$store.dispatch('logout').then(() => {
                                        this.$store.dispatch('login', {
                                            user: this.user
                                        }).then((response) => {
                                            if(response.success === true && response.result !== false && response.result.user) {
                                                this.success = this.$t('join.joinContextSuccess');
                                                setTimeout(this.forwardToSharesuite, 2000);
                                            } else {
                                                this.error = this.$t('join.errors.loginFailed');
                                            }
                                        }).catch((response) => {
                                            // This route doesn't use proper status code or anything its ridiculous
                                        }).finally(() => {
                                            this.loading = false;
                                        })
                                    })
                                }).catch((response) => {
                                    switch(response.status) {
                                        case 401:
                                            this.error = this.$t('join.errors.invitationInvalidName');
                                            break;
                                        case 404:
                                            this.error = this.$t('join.errors.invitationInvalid');
                                            break;
                                        case 406:
                                            this.error = this.$t('join.errors.invitationUsed', {context: this.context});
                                            break;
                                        case 409:
                                            this.error = this.$t('join.errors.alreadyInContext', {context: this.context})
                                            break;
                                        default:
                                            // Unexpected system errors
                                            this.error = this.$t('common.errors.commonError');
                                    }

                                    this.loading = false;
                                })
                            } else {
                                switch(response.result.errorId) {
                                    case 13:
                                        this.error = this.$t('join.errors.noContextAvailable');
                                        break;
                                    default:
                                        this.error = this.$t('join.errors.loginFailed');
                                        break;
                                }
                            }
                        }).catch((response) => {
                            // This route doesn't use proper status code or anything its ridiculous
                        }).finally(() => {
                            this.loading = false;
                        })
                    });
                }
            },
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .login-button {
        width: 100%;
        text-transform: initial;
    }

    .v-card__text {
        padding-bottom: 0 !important;
    }

    .header-image-container {
        height: 75px;
    }
</style>
